import { render, staticRenderFns } from "./quicktable.vue?vue&type=template&id=4a83e87c&"
import script from "./quicktable.vue?vue&type=script&lang=js&"
export * from "./quicktable.vue?vue&type=script&lang=js&"
import style0 from "./quicktable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports